import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { v4 as uuid } from 'uuid';

import { getIconForServiceCategory } from '../../utils';
import { FinnairBoundItem, FinnairPassengerItem } from '../../api/models';
import { FinnairServiceItemWithUpsell } from '../../interfaces';

@Component({
  selector: 'fin-dapi-included-product-item',
  styleUrls: ['./included-product-item.component.scss'],
  templateUrl: './included-product-item.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DapiIncludedProductItemComponent {
  uuid = uuid();

  @Input() category: string;
  @Input() buttonTranslationKey: string;
  @Input() additionalTitle: string;
  @Input() includePaddings = true;
  @Input() expandOpen = false;
  @Input() disabled = false;
  @Input() isShortHaulFlight: boolean;
  @Input() passengers: FinnairPassengerItem[];
  @Input() bound: FinnairBoundItem;
  @Input() service: FinnairServiceItemWithUpsell;

  getIconForService(): string {
    return getIconForServiceCategory(this.category);
  }
}
